<script setup lang="ts">
import { computed } from 'vue';
import { useAppStore } from '../stores/app';
import { blogPosts } from '../data/portfolio';

const appStore = useAppStore();

const posts = computed(() => blogPosts);
</script>

<template>
  <section id="blog" class="blog-section section">
    <div class="container">
      <h2 class="section-title">
        <i class="fas fa-newspaper"></i>
        {{ appStore.isZh ? '最新文章' : 'Latest Posts' }}
      </h2>
      <div class="section-divider"></div>
      <p class="section-subtitle">
        {{ appStore.isZh 
          ? '分享技术心得与项目经验，记录成长的每一步' 
          : 'Sharing technical insights and project experiences' }}
      </p>

      <div class="blog-grid">
        <article
          v-for="(post, index) in posts"
          :key="post.id"
          class="blog-card"
          :style="{ animationDelay: `${index * 0.1}s` }"
        >
          <a :href="post.url" class="blog-link">
            <div class="blog-image">
              <img :src="post.image" :alt="post.title" />
              <div class="blog-category">{{ post.category }}</div>
            </div>
            <div class="blog-content">
              <time class="blog-date">
                <i class="far fa-calendar-alt"></i>
                {{ post.date }}
              </time>
              <h3 class="blog-title">
                {{ appStore.isZh ? post.title : post.titleEn }}
              </h3>
              <p class="blog-excerpt">
                {{ appStore.isZh ? post.excerpt : post.excerptEn }}
              </p>
              <span class="read-more">
                {{ appStore.isZh ? '阅读更多' : 'Read More' }}
                <i class="fas fa-arrow-right"></i>
              </span>
            </div>
          </a>
        </article>
      </div>

      <div class="view-more">
        <a 
          href="https://www.ctkqiang.xin/bug-bounty-journal/" 
          target="_blank"
          rel="noopener noreferrer"
          class="nezha-btn nezha-btn-primary"
        >
          <i class="fas fa-book-open"></i>
          {{ appStore.isZh ? '浏览全部文章' : 'View All Posts' }}
        </a>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import '../styles/components/blog.css';
</style>
